import * as React from "react";

function Style1Icon(props) {
  return (
      
    <svg xmlns="http://www.w3.org/2000/svg" width="67" height="21" viewBox="0 0 67 26">
    <defs></defs>
    <g transform="translate(-24 -704)">
    <g className="a" transform="translate(24 717)" fill="#fff" stroke="#acacac" >
    <rect className="c" width="67" height="13" rx="2"  stroke="none" />
    <rect className="d" x="0.5" y="0.5" width="66" height="12" rx="1.5" fill="none" />
    </g>
    <text className="b" transform="translate(25 713)" fill="#7c7c7c">
    <tspan x="0" y="0">xxxx</tspan></text></g></svg>
 );
}

export default Style1Icon;